import { AxiosResponse } from "axios";
import { http } from "../utils/http";
import { CreatePatientFormData } from "../utils/constants";

/**
 * Crear un nuevo paciente desde la experiencia del médico/secretario
 * @param data - Datos del paciente a crear
 * @returns Promise con la respuesta del servidor
 */
export const createPatient = async (
  data: CreatePatientFormData
): Promise<AxiosResponse | any> => {
  try {
    const response = await http.post("/api/patient/pre-register", {
      ...data,
    });

    return response;
  } catch (error) {
    return error;
  }
};

/**
 * Obtener lista de pacientes (función existente movida desde doctor.ts si fuera necesario)
 * @param healthCoverageId - ID de cobertura médica
 * @param name - Nombre a buscar
 * @param doctorId - ID del doctor
 * @returns Promise con la lista de pacientes
 */
export const getPatient = async (
  healthCoverageId: string,
  name: string,
  doctorId: number
) => {
  try {
    const response = await http.get(`/api/patient`, {
      params: {
        healthCoverageId,
        name,
      },
      headers: doctorId
        ? {
            "x-doctor-id": doctorId,
          }
        : {},
    });
    return response.data;
  } catch (error) {
    return error;
  }
};
